import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-3 16h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2","key":"svg-0"}]]

/**
 * IconDeviceIpadFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItZGV2aWNlLWlwYWQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE4IDJhMyAzIDAgMCAxIDMgM3YxNGEzIDMgMCAwIDEgLTMgM2gtMTJhMyAzIDAgMCAxIC0zIC0zdi0xNGEzIDMgMCAwIDEgMyAtM3ptLTMgMTZoLTZhMSAxIDAgMCAwIDAgMmg2YTEgMSAwIDAgMCAwIC0yIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/device-ipad-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconDeviceIpadFilled = createReactComponent('filled', 'device-ipad-filled', 'DeviceIpadFilled', __iconNode);

export default IconDeviceIpadFilled;